module.exports = __webpack_public_path__ + "img/Deal_Card-grayscale.7a723522.jpg";